import { Button, useBreakpointValue } from '@chakra-ui/react';
import { Link } from '@tanstack/react-router';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { useIsMobile } from '$/hooks/useIsMobile';

interface Props {
  folderId?: string;
  schoolClassId?: string;
}

export const NewProjectButton: FC<Props> = ({ folderId, schoolClassId }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { canCreateMoreProjects, hasPermission } = useAuthorization();

  const headerText = useBreakpointValue({
    base: t('dashboard.welcome.newProjectButtonShort'),
    sm: t('dashboard.welcome.newProjectButton'),
  });

  return (
    <Button
      gap='1'
      h='10'
      fontSize='sm'
      borderRadius='4px'
      isDisabled={
        !hasPermission('Project_Create') || !canCreateMoreProjects() || isMobile
      }
      rightIcon={<Icon color='reverseText' icon='add_sign' w='4' />}
    >
      <Link
        to='/editor'
        search={() => ({ folderId, schoolClassId })}
        disabled={
          !hasPermission('Project_Create') ||
          !canCreateMoreProjects() ||
          isMobile
        }
      >
        {headerText}
      </Link>
    </Button>
  );
};
